import React from 'react'
import { searchIcon } from '@assets/images'
import { TextInput } from 'grommet'
import styled from 'styled-components'
import { useLanguage } from '@state/uses/app'

export default ({ search, onChange, onClick, searchPlaceholder }) => {
    const language = useLanguage()

    return language === 'he' ? (
        <SearchWrapper>
            <SearchInput
                value={search}
                placeholder={searchPlaceholder}
                onChange={(e) => onChange(e.target.value)}
                width={200}
            />
            <SearchImg src={searchIcon} onClick={onClick} />
        </SearchWrapper>
    ) : (
        <SearchWrapper>
            <SearchImg src={searchIcon} onClick={onClick} />
            <SearchInput
                value={search}
                placeholder={searchPlaceholder}
                onChange={(e) => onChange(e.target.value)}
                width={200}
            />
        </SearchWrapper>
    )
}

const SearchWrapper = styled.div`
    width: 100%;
    display: flex;
    /* max-width: 320px; */
    & > div {
        position: initial;
    }
    @media (max-width: 480px) {
        max-width: initial;
    }
`

const SearchInput = styled(TextInput)`
    font-size: 13px;
    font-weight: 300;
    text-align: right;
    width: 100%;
    height: 36px;
    background-color: white;
    outline-color: #cccccc;
    box-shadow: none;
    border: 1px solid #cccccc;
    &:focus {
        border: 1px solid #cccccc;
    }
`
const SearchImg = styled.img`
    width: 28px;
    height: 20px;
    background-color: white;
    margin-right: -32px;
    margin-top: 8px;
    z-index: 1;
    border: #ccc;
    &:hover {
        cursor: pointer;
    }
`
